export default [
  {
    id: 'addGroup',
    title: 'Add to group',
    icon: 'mdi-account-multiple-plus',
    action: 'addGroup'
  },
  {
    id: 'massiveDisableUsers',
    title: 'Disable',
    icon: 'mdi-cancel',
    action: 'massiveDisableUsers',
    _enabled: true
  },
  {
    id: 'massiveEnableUsers',
    action: 'massiveEnableUsers',
    title: 'Enable',
    icon: 'mdi-power-off',
    _enabled: true
  },
  {
    id: 'downloadUserNotifications',
    title: 'Download notifications',
    icon: 'mdi-download',
    action: 'downloadUserNotifications',
    _enabled: true
  },
  {
    id: 'delete',
    title: 'Delete',
    icon: 'mdi-delete',
    action: 'delete',
    _enabled: true
  }
];
